export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType('pmw-icon-button', {
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const el = document.createElement('div'),
                btnClass = props.class || '';
            el.className = "pmw-email-editor-icon-button radius-4 " + btnClass;

            if (typeof props.callback !== 'function') {
                props.callback = function () {
                };
            }

            if (typeof props.iconClass === 'undefined') {
                props.iconClass = 'icon-user';
            }

            if (typeof props.description === 'undefined') {
                props.description = '';
            }

            if (props.property === 'lock') {
                if (props.component) {
                    if (props.component.get('draggable')) {
                        props.description = i18next.t('pmwjs_lock');
                        props.iconClass = 'icon-lock';
                    } else {
                        props.description = i18next.t('pmwjs_unlock');
                        props.iconClass = 'icon-unlock';
                    }
                }
            }

            el.innerHTML = '<i class="pmw-icon-button-icon ' + props.iconClass + '"></i>' +
                '<span class="pmw-icon-button-text">' + props.description + '</span>';


            el.addEventListener('click', function (el, e) {
                change({el, e});
            }.bind(this, el)); // change will trigger the emit

            return el;
        },
        emit({props}, {el, event, complete}) {
            props.callback(el);
        },
        update({value, el}) {
        }
    });
}